function t(r) {
  return Array.isArray(r) ? r : [r.start.toArray(), r.end.toArray()];
}
export {
  t as Line3toLineV3
};
//# sourceMappingURL=index.js.map
